


























import { computed, defineComponent, ref } from '@vue/composition-api';
import { ScreenDialog } from '@tencent/wphk-ui';
import MyDonationModule from '@/components/my-donation-module/index.vue';
import { getServerTime, thousands } from '@/utils';
import dayjs from 'dayjs';
import { useStampStore } from '@/store/stamp';
import { storeToRefs } from 'pinia';
import { getHonoraryInfo } from '@/hooks/use-honorary';
import { language } from '@tencent/ppd-base-libs';
import SavePicture from '@/components/common/save-picture/index.vue';
import {
  hideLoading,
  showErrorDialog,
  showLoading,
} from '@tencent/wphk-act-base-ui';
import { i18n } from '@/i18n';

export default defineComponent({
  name: 'ExhcangeDialog',
  components: { ScreenDialog, MyDonationModule, SavePicture },
  props: {
    currentDonateNGO: { type: Object, default: () => ({ name: '', enName: '', sharepic: '' }), require: true },
  },
  setup(props) {
    // 弹窗
    const exchangeDialog = ref<InstanceType<typeof ScreenDialog> | null>(null);
    const show = () => {
      exchangeDialog.value?.show();
    };
    const hide = () => {
      exchangeDialog.value?.hide();
    };
    const isShowStampDetail = ref(true);

    const savePicture = ref<InstanceType<typeof SavePicture> | null>(null);

    // 数据
    const stampStore = useStampStore();
    const { userStampInfo, globalActInfo, currentNGO } = storeToRefs(stampStore);
    const honoraryInfo = computed(() => getHonoraryInfo(userStampInfo.value.usedCnt)); // 用户等级

    // 语言
    const isEn = ref(false);
    isEn.value = language.isEn();

    // 展示信息
    const info = computed(() => ({
      date: isEn.value ? dayjs(getServerTime()).format('MM/DD/YYYY') : dayjs(getServerTime()).format('YYYY.MM.DD'),
      usedCnt: userStampInfo.value.usedCnt,
      faceUrl: userStampInfo.value.faceUrl,
      nickName: userStampInfo.value.nickName,
      totalSendNum: globalActInfo.value.totalSendNum,
      userLevel: honoraryInfo.value?.nickName || '',
      ngoPic: props.currentDonateNGO.sharepic,
      ngoName: isEn.value ? props.currentDonateNGO.enName : props.currentDonateNGO.name,
      userTodayDonatedCount: currentNGO.value?.userTodayDonatedCount,
    }));

    const stampDetail = computed(() => {
      if (isShowStampDetail.value) {
        return i18n('於x為「x」捐出1個公益印花，累計捐贈x個公益印花，獻出第x個愛心', {
          userTodayDonatedCount: info.value.userTodayDonatedCount,
          date: info.value.date,
          ngoName: info.value.ngoName,
          usedCnt: info.value.usedCnt,
          totalSendNum: thousands(info.value.totalSendNum || 0),
        });
      }
      return i18n('感謝您為「x」捐出公益小紅花，獻出愛心！', {
        name: info.value.ngoName,
      });
    });

    return { exchangeDialog, show, hide, info, isEn,
      savePicture,
      stampDetail,
      handleSavePic(el: HTMLElement, cb: () => void) {
        showLoading();

        document.documentElement.scrollTop = 0;
        setTimeout(() => {
          savePicture.value
            ?.draw(el)
            .catch(() => {
              showErrorDialog({ message: i18n('圖片保存失敗') });
            })
            .finally(() => {
              hideLoading();
              cb();
            });
        }, 0);
      },
      handleSavePicShow() {
        hide();
      },
      showHideDetail(isShow) {
        isShowStampDetail.value = isShow;
      },
    };
  },
});
